import React from "react";
import { Check } from "lucide-react";

const services = [
  [
    "Stopcontacten",
    "Aardlekschakelaars",
    "Groepenkast uitbreiden",
    "Buitenverlichtingen aanleggen",
  ],
  [
    "Lampen installeren",
    "Perilex aansluitingen",
    "Renovatie van elektra",
    "Schakelaars en bekabelingen",
  ],
  [
    "Laadpaal installeren",
    "Krachtstroom aanleggen",
    "Inductiekookplaat aansluiten",
  ],
];

function ServicesOverview() {
  return (
    <section className="mx-auto w-[calc(100%-1rem)] max-w-[1088px] mb-12 md:mb-16 relative">
      <div className="relative py-10 px-8 bg-[#d5f0f6] rounded-xl overflow-hidden">
        <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-8">
          Wat wij ook doen in Arnhem
        </h2>

        <div className="flex flex-wrap gap-2">
          {services.flat().map((service, index) => (
            <div
              key={index}
              className="flex items-center gap-2 bg-white/50 rounded-lg px-3 py-2"
            >
              <Check className="w-4 h-4 text-[#17354A]" />
              <span className="text-[#17354A] text-[16px] md:text-[18px] font-medium whitespace-nowrap">
                {service}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesOverview;
